export default {
  props: {
    isReport: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      userAgreement: 'https://survey.work/userPolicy', //用户协议
      privacyPolicy: 'https://survey.work/privacyPolicy', //隐私政策
      report: 'https://survey.work/s/mZZZZfiJ', //举报
      currentYear: new Date().getFullYear()
    }
  },

  computed: {},

  mounted() {},

  methods: {
    toUrl(url) {
      window.open(url)
    }
  }
}
